import React, { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { mensagemErro } from '../modules/valores';

export default function Editor({ title, onClose, onSave, children, readOnly = false, label = 'Salvar' }) {
    const lock = useRef(false), aviso = useRef(null);
    const [busy, setBusy] = useState(false), [erro, setErro] = useState('');
    const close = () => { if (!lock.current) onClose(); };
    useEffect(() => { if (erro) aviso.current?.focus(); }, [erro]);
    async function submit(e) {
        e.preventDefault();
        if (lock.current || readOnly) return;
        // Validação nativa explícita permite apresentar o bloqueio também no diálogo.
        const form = e.currentTarget;
        const invalid = Array.from(form.elements).find(el => el.willValidate && !el.validity.valid);
        if (invalid) {
            const nome = invalid.labels?.[0]?.textContent?.replace(/\s*\*\s*$/, '').trim()
                || invalid.getAttribute('aria-label') || invalid.name || 'Campo obrigatório';
            setErro(nome + ': ' + (invalid.validationMessage || 'Confira o valor informado.'));
            invalid.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
            return;
        }
        lock.current = true; setBusy(true); setErro('');
        try { await onSave(); }
        catch (error) {
            const resposta = error?.response?.data?.message;
            const mensagem = typeof resposta === 'string' && resposta.trim() ? resposta : mensagemErro(error);
            setErro(typeof mensagem === 'string' && mensagem.trim() ? mensagem : 'Não foi possível concluir a operação. Tente novamente.');
        }
        finally { lock.current = false; setBusy(false); }
    }
    return <Dialog open onClose={close} fullWidth maxWidth="md"
        PaperProps={{ sx: { display: 'flex', flexDirection: 'column', maxHeight: 'calc(100% - 32px)' } }}>
        <DialogTitle sx={{ flexShrink: 0 }}>{title}</DialogTitle>
        <form noValidate onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
            {busy && <LinearProgress />}
            {erro && <Box sx={{ px: 3, pb: 1, flexShrink: 0 }}>
                <Alert ref={aviso} tabIndex={-1} role="alert" severity="error"
                    sx={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere', maxHeight: '25vh', overflowY: 'auto' }}>
                    {erro}
                </Alert>
            </Box>}
            <DialogContent dividers sx={{ minHeight: 0, overflowY: 'auto' }}>
                <fieldset disabled={busy} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>{children}</fieldset>
            </DialogContent>
            <DialogActions sx={{ flexShrink: 0 }}>
                <Button type="button" title="Fechar o formulário" onClick={close} disabled={busy}>Fechar</Button>
                {!readOnly && <Button type="submit" variant="contained" title="Salvar os dados preenchidos" disabled={busy}>{busy ? 'Salvando…' : label}</Button>}
            </DialogActions>
        </form>
    </Dialog>;
}
